import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { UserProvider, useUser } from "@/context/UserContext";
import Layout from "@/components/Layout";
import Kennisbank from "@/pages/Kennisbank";
import VraagAntwoord from "@/pages/VraagAntwoord";
import Salarischeck from "@/pages/Salarischeck";
import Functiecheck from "@/pages/Functiecheck";
import MijnOmgeving from "@/pages/MijnOmgeving";
import OrAnalyse from "@/pages/OrAnalyse"; // PILOTMAATREGEL v2: route tijdelijk uitgeschakeld, code blijft behouden
import Contractcheck from "@/pages/Contractcheck";
import AuditDashboard from "@/pages/AuditDashboard";
import AuthScreen from "@/pages/AuthScreen";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import AvgConsent from "@/pages/AvgConsent";
import Gebruikersbeheer from "@/pages/Gebruikersbeheer";
import FunctiecheckExperiment from "@/pages/FunctiecheckExperiment";
import Tilcheck from "@/pages/Tilcheck";
import Functiehandboek from "@/pages/Functiehandboek";
import CaoWijzer from "@/pages/CaoWijzer";
import FaqContact from "@/pages/FaqContact";
import { Voorwaarden, Privacy, Over } from "@/pages/LegalDoc";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";

const Shell = () => {
  const { loading, user, authEnabled } = useUser();

  // CRITICAL: verwerk de Google OAuth-terugkeer (session_id in fragment) vóór alle andere routing.
  if (authEnabled && typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF6EE]" data-testid="app-loading">
        <Loader2 className="w-6 h-6 animate-spin text-[#B9772B]" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/voorwaarden" element={<Voorwaarden />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/over" element={<Over />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={
        authEnabled && !user ? <AuthScreen /> :
        authEnabled && user && !user.juridisch_akkoord_actueel ? <AvgConsent /> : (
          <Layout>
            <Routes>
              <Route path="/" element={<VraagAntwoord />} />
              <Route path="/salaris" element={<Salarischeck />} />
              <Route path="/functie" element={<Functiecheck />} />
              <Route path="/tilcheck" element={<Tilcheck />} />
              <Route path="/functiehandboek" element={<Functiehandboek />} />
              <Route path="/cao" element={<CaoWijzer />} />
              <Route path="/faq" element={<FaqContact />} />
              <Route path="/mijn" element={<MijnOmgeving />} />
              {/* PILOTMAATREGEL v2 (2026-07): <Route path="/or-analyse" element={<OrAnalyse />} /> tijdelijk uit de pilot */}
              <Route path="/contractcheck" element={<Contractcheck />} />
              <Route path="/bronnen" element={<Kennisbank />} />
              <Route path="/dashboard" element={<AuditDashboard />} />
              <Route path="/gebruikers" element={<Gebruikersbeheer />} />
              <Route path="/functie-experiment" element={<FunctiecheckExperiment />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        )
      } />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <UserProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </UserProvider>
    </LanguageProvider>
  );
}

export default App;
